import React from 'react'
import styled from 'styled-components'

import { color } from 'styles/colors'
import { isSerialIdValid, isUnitTypeValid } from 'helpers/alerts'

type Props = {
  unitType?: string | null,
  serialId?:string | null,
  zoneId?: string | number | null,
  zoneName?: string | null,
  className?: string
}

const UnitSpecification = ({ unitType, serialId, zoneId, zoneName, className }: Props) => {
  const hasZoneInfo = zoneId !== null && zoneId !== 0

  return (
    <S.UnitSpecification className={className}>
      <div>
        {isUnitTypeValid(unitType, serialId) && <div>{unitType}</div>}
        {isSerialIdValid(serialId) && <><S.Label>S/N:</S.Label> <span>{serialId}</span></>}
      </div>
      {hasZoneInfo && (<div><S.Label>Zone ID: </S.Label><span>{zoneId} - {zoneName}</span></div>)}
    </S.UnitSpecification>
  )
}

export default UnitSpecification

const S = {
  UnitSpecification: styled.div`
    margin-top: 10px;
    color: ${color('primaryText')};
    font-size: 14px;
    font-weight: 600;
    text-align: right;
  `,
  Label: styled.span`
    color: ${color('secondaryText')};
  `
}
